import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderBase } from '../news-feed-item-header-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-news-feed-item-header-checklist',
    templateUrl: './news-feed-item-header-checklist.component.html',
    styleUrls: ['./news-feed-item-header-checklist.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemHeaderChecklistComponent extends NewsFeedItemHeaderBase {
    FiStateNames = FiStateNames;
}
